module.exports = __webpack_public_path__ + "img/78_40.c8003ea3.png";